var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegionsBank = function SvgRegionsBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "regions-bank_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".regions-bank_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81b83e"
    },
    d: "M0 0h40v26H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "regions-bank_svg__Calque_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg___x33_",
    className: "regions-bank_svg__st1",
    d: "m9.6 11.895 1.3-1.69.78 1.69H9.6zm1.365-1.755.65-.845.325 2.535-.975-1.69zM12.2 8.645l.52.585-.52 2.6-.52-2.6.52-.585zm.195 3.25.325-2.6.65.845-.975 1.755zm.195 0 .78-1.69 1.3 1.69h-2.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "regions-bank_svg___x32_",
    transform: "translate(47 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__R",
    className: "regions-bank_svg__st1",
    d: "M-35.06 7.365c.585.065.91-.13.91-.65 0-.39-.26-.585-.65-.585h-.26v1.235m-.715-.91c0-.26-.065-.39-.455-.455v-.065h1.56c.91 0 1.3.39 1.3.78 0 .325-.195.585-.65.715.39.065.715 1.04 1.04 1.365.065.065.195.13.325.13v.065h-.975c-.39-.455-.585-1.105-.845-1.365-.13-.13-.26-.13-.52-.13v.975c0 .26.13.39.455.455v.065h-1.56v-.065c.325 0 .455-.13.455-.39v-2.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__E",
    className: "regions-bank_svg__st1",
    d: "M-30.445 8.21c-.13-.195-.195-.325-.455-.325h-.455v.65c0 .26.13.325.39.325h.13c.325 0 .52-.26.52-.455h.065l-.065.52h-1.95V8.86c.325-.065.325-.13.325-.39V6.975c0-.195-.065-.325-.325-.325v-.065h1.95v.52h-.065c-.065-.325-.195-.39-.52-.39h-.52v.975h.455c.195 0 .325-.065.39-.325h.065l.065.845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__G",
    className: "regions-bank_svg__st1",
    d: "M-27.39 8.86c-.26.13-.585.195-.975.195-.91 0-1.43-.585-1.43-1.235 0-.715.585-1.3 1.43-1.3.39 0 .52.13.715.13.065 0 .13 0 .195-.065h.065v.65h-.065c-.195-.39-.52-.585-.845-.585-.52 0-.78.455-.78 1.17s.39 1.04.845 1.04c.26 0 .39-.065.39-.26v-.39c0-.195-.065-.26-.26-.325V7.82H-27v.13c-.195.065-.26.13-.26.39l-.13.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__I",
    className: "regions-bank_svg__st1",
    d: "M-25.7 8.6c0 .195.065.26.325.325v.13h-1.235V8.99c.26-.13.26-.195.26-.39V7.105c0-.195-.065-.26-.325-.325v-.065h1.235v.065c-.325.065-.325.195-.325.39V8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__O",
    className: "regions-bank_svg__st1",
    d: "M-23.425 6.715c-.52 0-.78.39-.78 1.17 0 .52.195 1.105.78 1.105.455 0 .78-.325.78-1.105.065-.715-.195-1.17-.78-1.17m0 2.34c-.78 0-1.43-.52-1.43-1.235s.585-1.3 1.43-1.3 1.43.52 1.43 1.3c0 .715-.585 1.235-1.43 1.235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__N",
    className: "regions-bank_svg__st1",
    d: "m-19.135 8.99-1.885-1.95v1.495c0 .26.065.325.39.39v.13h-.91V8.99c.325-.065.39-.195.39-.455v-1.56c-.195-.195-.26-.26-.39-.26V6.65h.78l1.495 1.56V7.17c0-.325-.065-.455-.325-.455V6.65h.845v.065c-.325 0-.39.195-.39.39V8.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__S",
    className: "regions-bank_svg__st1",
    d: "M-16.73 7.17c-.195-.325-.455-.52-.65-.52s-.455.13-.455.325c0 .065.065.195.13.26.13.13.715.455.845.52.195.195.325.39.325.52 0 .52-.52.65-.845.65-.325 0-.52-.13-.585-.13s-.13 0-.13.065h-.065v-.715h.065c.065.39.325.585.65.585s.52-.13.52-.39a.493.493 0 0 0-.13-.26c-.195-.195-.65-.39-.845-.52-.195-.13-.26-.325-.26-.52 0-.455.325-.65.78-.65h.26c.065 0 .195.065.26.065s.065 0 .13-.065h.065l-.065.78"
  })))));
};
export default SvgRegionsBank;